<div class="card">
  <div class="card align-items-center" *ngIf="circularProgressiveWait">
    <div card="card-body">
      <div class="spinner-border text-primary m-1" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <div class="card-body">
    <!-- Nav tabs -->
    <ul
      ngbNav
      #customNav="ngbNav"
      [activeId]="1"
      class="nav nav-tabs nav-tabs-custom"
    >
      <li [ngbNavItem]="1">
        <a ngbNavLink>
          <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
          <span class="d-none d-sm-block">Process Structure</span>
        </a>
        <ng-template ngbNavContent>
          <ng-template [ngTemplateOutlet]="TabProcessStructure"></ng-template>
        </ng-template>
      </li>
      <li [ngbNavItem]="2">
        <a ngbNavLink>
          <span class="d-block d-sm-none"><i class="fa-automobile"></i></span>
          <span class="d-none d-sm-block">Process Items</span>
        </a>
        <ng-template ngbNavContent>
          <ng-template [ngTemplateOutlet]="TabProcessItems"></ng-template>
        </ng-template>
      </li>
    </ul>

    <!-- Tab panes -->
    <div class="tab-content p-3 text-muted">
      <div [ngbNavOutlet]="customNav"></div>
    </div>
  </div>
</div>
<ng-template #TabProcessStructure>
  <div class="card-header" style="text-align: end">
    <button
      class="btn btn-primary"
      (click)="
        startConfigureDialogProcess(); openModal(modalCreateDialogProcessStructure)
      "
    >
      Configurar novo processo
    </button>
  </div>
  <div class="card overflow-auto">
    <div class="card-body">
      <div class="row">
        <ng-container *ngIf="processStructures[0].length > 0">
          <ng-container
            *ngFor="let processStructure of processStructures; let i = index"
          >
            <div class="col-md-10">
              <ngb-accordion #acc="ngbAccordion">
                <ngb-panel id="static-1">
                  <ng-template ngbPanelTitle class="accordion-header">
                    <h2 class="accordion-header" id="gen-ques-headingOne">
                      <button
                        class="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#gen-ques-collapseOne"
                        aria-expanded="false"
                        aria-controls="gen-ques-collapseOne"
                      >
                        {{ processStructure[0].group }} -
                        {{ processStructure[0].name }} - (Qtd etapas:
                        {{ processStructure.length }})
                      </button>
                    </h2>
                  </ng-template>

                  <ng-template ngbPanelContent>
                    <table class="table table-fit table-bordered table-hover">
                      <thead class="table-primary">
                        <tr>
                          <th class="text-center" scope="col">Grupo</th>
                          <th class="text-center" scope="col">Nome</th>
                          <th class="text-center" scope="col">Parâmetros</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="let processStructure of processStructures[i]"
                        >
                          <td class="text-center" scope="row">
                            {{ processStructure.group }}
                          </td>
                          <td class="text-center" scope="row">
                            {{ processStructure.name }}
                          </td>
                          <td class="text-center" scope="row">
                            <ngb-accordion #acc="ngbAccordion">
                              <ngb-panel id="static-structure-item">
                                <ng-template
                                  ngbPanelTitle
                                  class="accordion-header"
                                >
                                  <h2
                                    class="accordion-header"
                                    id="gen-ques-headingOne"
                                  >
                                    <button
                                      class="accordion-button"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#gen-ques-collapseOne"
                                      aria-expanded="false"
                                      aria-controls="gen-ques-collapseOne"
                                    >
                                      Step:{{ processStructure.step }} -
                                      {{ processStructure.description }} -
                                      {{ processStructure.type }}
                                      <ng-container
                                        *ngIf="
                                          getValueObject(
                                            processStructure,
                                            'analyticNextStepIfTrue'
                                          ) != 0
                                        "
                                      >
                                        <div class="badge bg-success ms-2">
                                          True->
                                          {{
                                            getValueObject(
                                              processStructure,
                                              "analyticNextStepIfTrue"
                                            )
                                          }}
                                        </div>
                                      </ng-container>
                                      <ng-container
                                        *ngIf="
                                          getValueObject(
                                            processStructure,
                                            'analyticNextStepIfFalse'
                                          ) != 0
                                        "
                                      >
                                        <div class="badge bg-danger ms-2">
                                          False->
                                          {{
                                            getValueObject(
                                              processStructure,
                                              "analyticNextStepIfFalse"
                                            )
                                          }}
                                        </div>
                                      </ng-container>
                                    </button>
                                  </h2>
                                </ng-template>

                                <ng-template ngbPanelContent>
                                  <table
                                    class="table table-fit table-bordered table-hover"
                                  >
                                    <thead class="table-primary">
                                      <tr>
                                        <th>Parametro</th>
                                        <th>Valor</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        *ngFor="
                                          let key of getObjectKeys(
                                            processStructure
                                          )
                                        "
                                      >
                                        <td>{{ key }}</td>
                                        <td>
                                          {{
                                            getValueObject(
                                              processStructure,
                                              key
                                            )
                                          }}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </ng-template>
                              </ngb-panel>
                            </ngb-accordion>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </ng-template>
                </ngb-panel>
              </ngb-accordion>
            </div>

            <div
              class="col-md-2"
              style="display: inline-flex; align-items: center"
            >
              <span>{{ processStructure[0].status }}</span>
              <i
                class="fa fa-play-circle"
                aria-hidden="true"
                style="cursor: pointer"
              ></i>
              <i
                class="fa fa-pause-circle"
                aria-hidden="true"
                style="cursor: pointer"
              ></i>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #TabProcessItems>
  <div class="card overflow-auto">
    <div class="card-body">
      <div class="card m-2" style="display: inline-block">
        <label>Pesquisar seriais</label>
        <input
          class="input"
          [(ngModel)]="processAutoItemsBySerial"
          class="input"
          type="text"
          placeholder="Seriais separados por ;"
        />
        <button
          class="btn btn-sm btn-primary"
          (click)="getProcessAutoItemsBySerial()"
        >
          Pesquisar
        </button>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="card m-3">
            <div style="text-align-last: center">
              <ng-container *ngIf="processItemsAux.length > 0">
                <button
                  class="btn btn-sm btn-primary"
                  (click)="openModal(modalResetAttemptsProcessItem)"
                >
                  Reiniciar tentativa
                </button>
                <button
                  class="btn btn-sm btn-success"
                  (click)="openModal(modalResetProcessItem)"
                >
                  Reiniciar processo
                </button>
              </ng-container>
              <ng-container
                *ngIf="getCountProcessItemsDuplicateSameGroup() > 0"
              >
                <button
                  class="btn btn-sm btn-danger"
                  (click)="openModal(modalRemoveDuplicatedSeriasSameGrupo)"
                >
                  <span
                    >Remover duplicado<br />
                    mesmo processo</span
                  >
                </button></ng-container
              >
            </div>
            <div>
              <span>Filtro</span>
              <div class="d-flex" style="flex-wrap: wrap">
                <div style="min-width: 50%">
                  <ng-select #filterKey>
                    <ng-option
                      *ngFor="let key of getObjectKeys(processItemsFilter)"
                      [value]="key"
                    >
                      {{ key }}
                    </ng-option>
                  </ng-select>
                </div>
                <ng-container *ngIf="filterKey.selectedValues[0]">
                  <ng-select
                    #conditionFilter
                    [ngStyle]="{
                      display:
                        getObjectType(filterKey.selectedValues[0]) == 'number'
                          ? ''
                          : 'none',
                      width: '100px'
                    }"
                  >
                    <ng-option value="=="> == </ng-option>
                    <ng-option value=">="> >= </ng-option>
                    <ng-option value="=<"> =< </ng-option>
                    <ng-option value="<>"> <> </ng-option>
                  </ng-select>
                  <input
                    class="input m-2"
                    [type]="getObjectType(filterKey.selectedValues[0])"
                    #filterValue
                  />
                  <button
                    class="btn btn-sm btn-primary"
                    [disabled]="
                      getObjectType(filterKey.selectedValues[0]) == 'number' &&
                      conditionFilter.selectedValues[0] == undefined
                    "
                    (click)="
                      addFilter(
                        filterKey.selectedValues[0],
                        conditionFilter.selectedValues[0],
                        filterValue.value
                      );
                      filterProcessItems();
                      filterValue.value = ''
                    "
                  >
                    +
                  </button>
                </ng-container>
              </div>
            </div>
            <div class="d-flex">
              <div
                class="card d-inline m-2"
                style="max-inline-size: fit-content"
                *ngFor="let filter of filters"
              >
                <button
                  class="btn btn-sm btn-danger"
                  (click)="removeFilter(filter); filterProcessItems()"
                >
                  -
                </button>
                {{ filter.key }}: {{ filter.value }}
              </div>
            </div>
          </div>

          <div class="w-100"></div>
          <div>
            <div class="badge bg-success ms-2">
              Contagem {{ processItemsAux.length }}
            </div>
            <div class="badge bg-warning ms-2">
              Duplicados {{ getCountProcessItemsDuplicate() }}
            </div>
            <div class="badge bg-danger ms-2">
              Duplicados mesmo processo
              {{ getCountProcessItemsDuplicateSameGroup() }}
            </div>
          </div>

          <div>
            <table class="table table-fit table-bordered table-hover">
              <thead class="table-primary">
                <tr>
                  <th class="text-center" scope="col">Serial</th>
                  <th class="text-center" scope="col">Parâmetros</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let processItem of processItemsAux">
                  <td class="text-center" scope="row">
                    {{ processItem.serial }}
                  </td>

                  <td class="text-center" scope="row">
                    <table class="table table-fit table-bordered table-hover">
                      <thead class="table-primary">
                        <tr>
                          <th>Parametro</th>
                          <th>Valor</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let key of getObjectKeys(processItem)">
                          <td>{{ key }}</td>
                          <td>
                            {{ getValueObject(processItem, key) }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="col-md-6">
          <div>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              (click)="openModal(modalIncludeAll)"
              style="background-color: green"
              ngbTooltip="Novo Comando"
              [disabled]="processItems[1].length == 0"
            >
              Incluir no processo
            </button>
          </div>
          <div>
            <table class="table table-fit table-bordered table-hover">
              <thead class="table-primary">
                <tr>
                  <th class="text-center" scope="col">Serial</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let itemNot of processItems[1]">
                  <td class="text-center" scope="row">
                    {{ itemNot }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<div class="w-100"></div>

<!-- Dialog IncludeAll -->
<ng-template #modalIncludeAll let-modal>
  <div class="card align-items-center" *ngIf="circularProgressiveWait">
    <div card="card-body">
      <div class="spinner-border text-primary m-1" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <div class="card align-items-center" *ngIf="!circularProgressiveWait">
    <div class="modal-header">
      <h5 class="modal-title mt-0">Incluir seriais no processo</h5>
      <button
        type="button"
        class="btn btn-close"
        (click)="modal.dismiss('Cross click'); modalFinished = false"
        aria-hidden="true"
      ></button>
    </div>
    <div class="modal-body w-100">
      <ng-select
        class="w-100 mb-3"
        id="processSelect"
        placeholder="Selecione um processo"
        #processStructureIncludeInGroup
      >
        <ng-option
          *ngFor="let processStructure of processStructures; let i = index"
          [value]="processStructure[0].group"
        >
          {{ processStructure[0].name }}
        </ng-option>
      </ng-select>
      <div style="text-align-last: center">
        <button
          class="btn btn-sm btn-success"
          [disabled]="modalFinished"
          (click)="
            includeAllInGroup(processStructureIncludeInGroup.selectedValues[0])
          "
        >
          Confirmar
        </button>
        <button
          class="btn btn-sm btn-danger"
          [disabled]="modalFinished"
          (click)="modal.dismiss(); modalFinished = false"
        >
          Cancelar
        </button>
        <div>
          <span *ngIf="modalFinished" style="color: green">
            Incluido com sucesso, feche a pop up
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Dialog ResetProcessItem -->
<ng-template #modalResetProcessItem let-modal>
  <div class="card align-items-center" *ngIf="circularProgressiveWait">
    <div card="card-body">
      <div class="spinner-border text-primary m-1" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <div class="card align-items-center" *ngIf="!circularProgressiveWait">
    <div class="modal-header">
      <h5 class="modal-title mt-0">
        Reiniciar o processo dos items filtrados?
      </h5>
      <button
        type="button"
        class="btn btn-close"
        (click)="modal.dismiss('Cross click'); modalFinished = false"
        aria-hidden="true"
      ></button>
    </div>
    <div class="modal-body">
      <div>
        <div>
          <div class="form-group">
            <label>Definir uma etapa?</label>
            <input
              #currentStep
              class="input checkbox m-2"
              ngbTooltip="Se não selecionada e definida, irá voltar para a primeira etapa"
              id="currentStep"
              type="checkbox"
            />
          </div>
        </div>
        <div>
          <div
            [ngStyle]="{ display: currentStep.checked ? '' : 'none' }"
            class="form-group"
          >
            <input
              #currentStepInput
              id="currentStepInput"
              type="number"
              min="1"
            />
          </div>
        </div>
      </div>
      <div style="text-align-last: center">
        <button
          class="btn btn-sm btn-success"
          [disabled]="modalFinished"
          (click)="resetProcessItems(currentStepInput.value)"
        >
          Confirmar
        </button>
        <button
          class="btn btn-sm btn-danger"
          [disabled]="modalFinished"
          (click)="modal.dismiss(); modalFinished = false"
        >
          Cancelar
        </button>
        <div>
          <span *ngIf="modalFinished" style="color: green">
            Items reiniciados com sucesso, feche a pop up
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Dialog ResetAttemptsProcessItem -->
<ng-template #modalResetAttemptsProcessItem let-modal>
  <div class="card align-items-center" *ngIf="circularProgressiveWait">
    <div card="card-body">
      <div class="spinner-border text-primary m-1" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <div class="card align-items-center" *ngIf="!circularProgressiveWait">
    <div class="modal-header">
      <h5 class="modal-title mt-0">
        Reiniciar as tentativas dos items filtrados?
      </h5>
      <button
        type="button"
        class="btn btn-close"
        (click)="modal.dismiss('Cross click'); modalFinished = false"
        aria-hidden="true"
      ></button>
    </div>
    <div class="modal-body">
      <div style="text-align-last: center">
        <button
          class="btn btn-sm btn-success"
          [disabled]="modalFinished"
          (click)="resetAttempts()"
        >
          Confirmar
        </button>
        <button
          class="btn btn-sm btn-danger"
          [disabled]="modalFinished"
          (click)="modal.dismiss(); modalFinished = false"
        >
          Cancelar
        </button>
        <div>
          <span *ngIf="modalFinished" style="color: green">
            Tentativas reiniciados com sucesso, feche a pop up
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Dialog ResetAttemptsProcessItem -->
<ng-template #modalRemoveDuplicatedSeriasSameGrupo let-modal>
  <div class="card align-items-center" *ngIf="circularProgressiveWait">
    <div card="card-body">
      <div class="spinner-border text-primary m-1" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <div class="card align-items-center" *ngIf="!circularProgressiveWait">
    <div class="modal-header">
      <h5 class="modal-title mt-0">
        Deseja remover os duplicados do mesmo grupo?
      </h5>
      <button
        type="button"
        class="btn btn-close"
        (click)="modal.dismiss('Cross click'); modalFinished = false"
        aria-hidden="true"
      ></button>
    </div>
    <div class="modal-body">
      <div style="text-align-last: center">
        <button
          class="btn btn-sm btn-success"
          [disabled]="modalFinished"
          (click)="removeDuplicatedSameProcessGroup()"
        >
          Confirmar
        </button>
        <button
          class="btn btn-sm btn-danger"
          [disabled]="modalFinished"
          (click)="modal.dismiss(); modalFinished = false"
        >
          Cancelar
        </button>
        <div>
          <span *ngIf="modalFinished" style="color: green">
            Seriais duplicados removido com sucesso, feche a pop up
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Dialog modalCreateDialogProcessStructure -->
<ng-template #modalCreateDialogProcessStructure let-modal>
  <div class="overflow-auto">
    <div class="card align-items-center" *ngIf="circularProgressiveWait">
      <div card="card-body">
        <div class="spinner-border text-primary m-1" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div class="card align-items-center" *ngIf="!circularProgressiveWait">
      <div class="modal-header">
        <h5 class="modal-title mt-0">Criar novo processo</h5>
        <button
          type="button"
          class="btn btn-close"
          (click)="modal.dismiss('Cross click'); modalFinished = false"
          aria-hidden="true"
        ></button>
      </div>
      <div class="modal-body w-100">
        <ng-container *ngIf="isConfigureDialogProcess">
          <div class="card">
            <div class="card">
              <div class="input-group input-group-sm mb-2">
                <span class="input-group-text">Nome do processo</span>
                <input
                  [(ngModel)]="processStructuresFormName"
                  type="text"
                  class="form-control"
                />
              </div>
              <div class="align-items-center" style="display: inline-flex">
                <ng-container
                  *ngFor="let item of processStructuresFormLst; let i = index"
                >
                  <div class="grid" style="text-align: center">
                    <div
                      class="shape m-2 col-12"
                      [ngClass]="{
                        circle: isCircle(processStructuresFormLst[i]),
                        losango: isLosango(processStructuresFormLst[i]),
                        square: isEnd(processStructuresFormLst[i])
                      }"
                      (click)="changeStep(i)"
                      [ngStyle]="{
                        'background-color': getBackgroundColor(i),
                        color: 'white'
                      }"
                    >
                      <span
                        class="shape-text"
                        *ngIf="!isEnd(processStructuresFormLst[i])"
                        >{{ i + 1 }}</span
                      >
                      <span
                        class="shape-text"
                        *ngIf="isEnd(processStructuresFormLst[i])"
                        >Fim</span
                      >
                    </div>
                    <span
                      *ngIf="isEnd(processStructuresFormLst[i])"
                      style="font-size: xx-small"
                      >não incluso</span
                    >
                    <ng-container
                      *ngIf="
                        processStructuresFormLst[i].analyticNextStepIfTrue !=
                        undefined
                      "
                    >
                      <div>
                        <div class="d-block col-12">
                          <div class="badge bg-success">
                            <i
                              class="fa fa-check"
                              aria-hidden="true"
                              style="color: green"
                            ></i>
                            {{
                              processStructuresFormLst[i].analyticNextStepIfTrue
                            }}
                          </div>
                          <div class="badge bg-warning">
                            <i
                              class="fa fa-times"
                              aria-hidden="true"
                              style="color: red"
                            ></i>
                            {{
                              processStructuresFormLst[i]
                                .analyticNextStepIfFalse
                            }}
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </div>
            <form
              [formGroup]="processStructuresForm"
              (ngSubmit)="saveNewProcessStructure()"
            >
              <h4>Etapa {{ wizardState + 1 }}</h4>
              <div class="input-group input-group-sm mb-2">
                <span class="input-group-text">Descrição</span>
                <input
                  formControlName="description"
                  type="text"
                  class="form-control"
                />
              </div>
              <div class="input-group input-group-sm mb-2">
                <span class="input-group-text"
                  >Tempo para esperar antes de executar esta etapa (min)</span
                >
                <input
                  class="form-control"
                  formControlName="waitBeforeBeginStep"
                />
              </div>

              <ng-container
                *ngIf="
                  !checkLastProcessStructureStep('responseCommand', wizardState)
                "
              >
                <div class="input-group input-group-sm mb-2">
                  <span class="input-group-text">Enviar Comando</span>
                  <input
                    #processStructureSendCommand
                    formControlName="isSendCommand"
                    type="checkbox"
                  />
                </div>
                <ng-container *ngIf="processStructureSendCommand.checked">
                  <div id="command-container" class="card">
                    <span style="align-self: center"><b>Comando</b></span>
                    <div class="input-group input-group-sm mb-2">
                      <span class="input-group-text">Comando</span>
                      <ng-select
                        style="min-width: 300px"
                        id="commandSelect"
                        placeholder="Selecione um comando"
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="commandSelect.nome"
                        (click)="filterCommand(commandSelect.nome)"
                      >
                        <ng-option *ngFor="let command of commandInfoType">
                          {{ command.nome }}
                        </ng-option>
                      </ng-select>
                    </div>

                    <div *ngIf="commandSelect.valor">
                      <span
                        class="card font-weight-bold ms-2"
                        [innerHTML]="commandSelect.observacaoHTML"
                      >
                      </span>
                    </div>
                    <div
                      *ngIf="commandSelect.valor"
                      class="input-group input-group-sm mb-2"
                    >
                      <span class="input-group-text">Parâmetros</span>
                      <input
                        class="form-control w-75"
                        [placeholder]="commandSelect.exemplo"
                        formControlName="commandParam"
                      />
                    </div>
                    <div class="input-group input-group-sm mb-2">
                      <span class="input-group-text">Timeout</span>
                      <ng-select
                        style="min-width: 300px"
                        formControlName="commandTimeOut"
                      >
                        <ng-option
                          *ngFor="let item of timeOutKeys; let i = index"
                          [value]="timeOutValues[i]"
                        >
                          {{ item }}
                        </ng-option>
                      </ng-select>
                    </div>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container
                *ngIf="
                  checkLastProcessStructureStep(
                    'responseCommand',
                    wizardState
                  ) && processStructuresFormLst.length > 1
                "
              >
                <!-- <div class="input-group input-group-sm mb-2">
                <span class="input-group-text">Reposta do comando</span>
                <input
                  type="checkbox"
                  formControlName="isAnalyticResponseCommand"
                  value="true"
                  checked
                />
              </div> -->
                <div id="command-container" class="card">
                  <span style="align-self: center"
                    ><b>Análise resposta do comando</b></span
                  >
                  <div class="input-group input-group-sm mb-2">
                    <span class="input-group-text">Lógica</span>
                    <ng-select
                      formControlName="analyticPositionLogic"
                      style="min-width: 100px"
                      id="analytic-logic-command-response"
                      placeholder="Selecione uma lógica"
                    >
                      <ng-option value="like"> like </ng-option>
                    </ng-select>
                  </div>
                  <div class="input-group input-group-sm mb-2">
                    <span class="input-group-text">Split</span>
                    <input
                      #splitValueCommandResponse
                      formControlName="analyticIsSplitValue"
                      type="checkbox"
                    />
                  </div>

                  <div *ngIf="splitValueCommandResponse.checked">
                    <div class="input-group input-group-sm mb-2">
                      <span class="input-group-text">Splitar por</span>
                      <input
                        class="form-control"
                        formControlName="analyticSplitValue"
                        type="text"
                        style="min-width: 50px"
                        placeholder="Exmple: ALL="
                      />
                    </div>
                    <div class="input-group input-group-sm mb-2">
                      <span class="input-group-text"
                        >Analisar a partir de qual elemento</span
                      >
                      <input
                        class="form-control"
                        type="number"
                        style="min-width: 50px"
                        formControlName="analyticValueIndex"
                      />
                    </div>
                  </div>
                  <div class="input-group input-group-sm mb-2">
                    <span class="input-group-text">Case sensitive</span>
                    <input
                      type="checkbox"
                      formControlName="analyticCaseSensitive"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-2">
                    <span class="input-group-text">Valor esperado</span>
                    <input
                      class="form-control"
                      formControlName="analyticPositionValueExpected"
                      type="text"
                      style="min-width: 50px"
                      placeholder="Exmple: %vivo%"
                    />
                    <ng-container *ngIf="">
                      <div class="card">
                        <span
                          >Se escolhido o tipo like, utilizar as regras do uso
                          do %
                        </span>
                      </div>
                    </ng-container>
                  </div>
                  <div class="input-group input-group-sm mb-2">
                    <span class="input-group-text">
                      <i
                        class="fa fa-check"
                        aria-hidden="true"
                        style="color: green"
                      ></i>
                      Etapa se sucesso</span
                    >
                    <input
                      class="form-control"
                      type="number"
                      formControlName="analyticNextStepIfTrue"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-2">
                    <span class="input-group-text">
                      <i
                        class="fa fa-times"
                        aria-hidden="true"
                        style="color: red"
                      ></i>
                      Etapa se falha</span
                    >
                    <input
                      class="form-control"
                      type="number"
                      formControlName="analyticNextStepIfFalse"
                    />
                  </div>
                </div>
              </ng-container>
              <div class="input-group input-group-sm mb-2">
                <span class="input-group-text"
                  >Manter reposta para a próxima etapa?</span
                >
                <input
                  formControlName="analyticKeepRequestCommandIdAfterCheck"
                  type="checkbox"
                />
              </div>
              <ul class="list-inline wizard mb-0">
                <li class="next list-inline-item float-end">
                  <button
                    *ngIf="
                      processStructuresFormLst.length > 0 &&
                      processStructuresFormLst.length - 1 != wizardState
                    "
                    type="button"
                    class="btn btn-primary w-sm"
                    awNextStep
                    (click)="nextStep()"
                  >
                    Próximo
                  </button>
                </li>
              </ul>
              <div *ngIf="processStructuresForm.hasError('message')">
                <span class="text-danger">
                  <ul>
                    <li
                      *ngFor="
                        let item of processStructuresForm.getError('message')
                      "
                    >
                      {{ item }}
                    </li>
                  </ul>
                </span>
              </div>
              <div>
                <button
                  class="btn btn-danger"
                  type="submit"
                  [disabled]="
                    processStructuresFormName.length < 5 &&
                    !hasErrorNewProcessStructure()
                  "
                >
                  Finalizar e Salvar
                </button>
                <ng-container
                  *ngIf="
                    !processStructuresFormLst[wizardState].stepDidConfig &&
                    !isProcessStructuresFormEdit
                  "
                >
                  <button
                    class="btn btn-primary ms-5"
                    type="button"
                    (click)="includeNewProcessStructureLocal()"
                    [disabled]="processStructuresForm.invalid"
                  >
                    Incluir
                  </button>
                </ng-container>
                <ng-container
                  *ngIf="
                    processStructuresFormLst[wizardState].stepDidConfig &&
                    isProcessStructuresFormEdit
                  "
                >
                  <button
                    class="btn btn-primary ms-5"
                    type="button"
                    (click)="editProcessStructorLocal(wizardState)"
                    [disabled]="processStructuresForm.invalid"
                  >
                    Salvar edição
                  </button>
                </ng-container>
              </div>
            </form>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>
